module.exports = __webpack_public_path__ + "static/media/education-object-1-2-0.43e963cc.png";